import { Injectable } from "@angular/core";
import { Logradouro } from "@tivic-team/manager-ts/dist/grl";
import { LogradouroController } from "app/controllers/grl/logradouro.controller";
import { PagedResponse } from "app/interfaces/paged-response.inteface";
import { LogradouroDTO } from "app/model/dtos/grl/logradouro.dto";
import { LoaderService } from "../loader.service";
import { LogradouroSearch } from "./logradouro.search";



@Injectable()
export class LogradouroServices {
    constructor(
        private _logradouroController: LogradouroController,
        private _loaderService: LoaderService
    ) { }

    async find(logradouroSearch?: LogradouroSearch): Promise<Logradouro[]> {
        this._loaderService.show();
        return await this._logradouroController.find(logradouroSearch && logradouroSearch.getFilters() || null)
        .finally(() => this._loaderService.hide()); 
    }

    async findLogradouros(logradouroSearch?: LogradouroSearch): Promise<PagedResponse<LogradouroDTO>> {
        this._loaderService.show();
        return await this._logradouroController.findLogradouros(logradouroSearch && logradouroSearch.getFilters() || null)
        .finally(() => this._loaderService.hide());  
    }

    async get(cdLogradouro: number): Promise<any> {
        this._loaderService.show();
        return this._logradouroController.get(cdLogradouro).finally(() => this._loaderService.hide());
    }

    async save( logradouroDTO: LogradouroDTO ):Promise<LogradouroDTO> {
        this._loaderService.show();
        if( logradouroDTO.cdLogradouro && logradouroDTO.cdLogradouro > 0 ) {
            return this._logradouroController.update(logradouroDTO).finally( () => this._loaderService.hide() );
        } else {
            return this._logradouroController.create(logradouroDTO).finally( () => this._loaderService.hide() );
        }
    }
}